// import $ from 'jquery';
import Cropper from 'cropperjs';
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

$(document).ready(function () {

    /*Ajax form saves*/
    let form = $('.ajax-form');
    form.each(function () {
        let this_form = this;
        $(this_form).validate({
            // focusCleanup: true,
            validClass: "is-valid",
            errorClass: 'is-invalid',
            wrapper: 'span',
            errorElement: 'small',
            submitHandler: function () {
                sendData(this_form);
            },
        })
    })

    /*Form function*/
    function sendData(form) {

        let response_box = $(form).closest('.card').parent();
        const formId = $(form).parent().attr('id');

        $.ajax({
            url: form.action,
            type: 'POST',
            data: new FormData(form),
            cache: false,
            contentType: false,
            processData: false,
            beforeSend: () => {
                $('.invalid-feedback').remove();
                $(response_box).find('input').removeClass('is-invalid');
                $(response_box).find('textarea').removeClass('is-invalid');
                resetButton($(form), '<span class="spinner-border spinner-border-sm mt-0" role="status" aria-hidden="true"></span> Saving', 'btn btn-primary btn-sm loader');
            },
            success: function(data){
                fadeOut($(form).closest('.card'));
                setTimeout(function (){
                    fadeIn($(form).closest('.card'));
                    resetButton($(form), '<i class="fa fa-check"></i> Data updated', 'btn-success btn-sm');
                    clearInputByType(formId, 'password');
                }, 1000);

                setTimeout(function (){
                    resetButton($(form), '<i class="fa fa-floppy-o"></i> Save', 'btn btn-primary btn-sm');
                }, 5000);

                if(data.redirect) window.location.replace(data.redirect);
            },
            error: function(err){
                resetButton($(form), '<i class="fas fa-exclamation-circle"></i> Errors', 'btn-danger btn-sm');

                setTimeout(function (){
                    resetButton($(form), '<i class="fa fa-floppy-o"></i> Save', 'btn btn-primary btn-sm');
                }, 3000);
                showErrors(err, formId);
            }
        });
    }

    /*custom fadeOut and fadeIn*/
    function fadeOut(element) {
        $(element).animate({
            opacity: 0.5,
            transform: 'scale(0.9)'
        }, 500)
    }

    function fadeIn(element) {
        $(element).animate({
            opacity: 1,
            transform: 'scale(1)'
        }, 500)
    }

    /* Reset Buttons */
    function resetButton(el, text, className) {
        el.find('button')
            .attr('class', className)
            .html(text)
    }

    /* Sticky sidebar */

    $('.sticky-block').each(function () {
        $(this).theiaStickySidebar({
            additionalMarginTop: 120,
            containerSelector: '.row'
        })
    });

    /* Edit Profile */

    $('body').on('click', '.toggle-input', function () {
        let form = $('.' + $(this).data('form')),
            status = '';
        // console.log();
        if($(this).find('input').prop('checked') == true) {
            form.find('input').each(function () {
                // console.log($(this));
                if($(this).attr('value') !== '') {
                    $(this).prop('disabled', false);
                    $(this).toggleClass('disabled form-control is-valid');
                }
            });
            form.find('textarea').each(function () {
                // console.log($(this));
                if($(this).attr('value') !== '') {
                    $(this).prop('disabled', false);
                    $(this).toggleClass('disabled form-control is-valid');
                }
            });
            form.find('select').each(function () {
                /*if($(this).find('option[selected]').length) {
                    $(this).prop('disabled', false);
                }*/
                $(this).prop('disabled', false);
            });
            form.find($('button[type="submit"]')).prop('disabled', false);
        } else {
            form.find('input').each(function () {
                // console.log($(this));
                if($(this).attr('value') !== '') {
                    $(this).prop('disabled', true);
                    $(this).add('disabled');
                }
            });
            form.find('textarea').each(function () {
                // console.log($(this));
                if($(this).attr('value') !== '') {
                    $(this).prop('disabled', true);
                    $(this).add('disabled');
                }
            });
            form.find('select').each(function () {
                $(this).prop('disabled', true);
            });
            form.find($('button[type="submit"]')).prop('disabled', true);
        }
    });

});

